import { memo } from "react";
import CloseModal from "./CloseModal";
import Dropdown from "./Dropdown";
import { SaveIcon } from "./IconButtons";

const RecruiterAssigning = memo(({formData, options, disabled, loading, errors, onAssignDate, onClose, onChange, onSubmit}) => {
    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-50 flex items-center justify-center blurBack'>
            <div className='relative w-[50vw] bg-white overflow-auto mx-10 mb-5 pb-6 rounded-2xl '>
                <CloseModal disabled={loading} onClick={onClose} />
                <SaveIcon disabled={loading} loading={loading} btnName="Assign" className=" top-3 left-3" onClick={onSubmit} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Assign Recruiter</h1>
                <form className='text-left flex flex-col gap-x-4 gap-y-3 px-2 mt-3 max-h-[70vh] overflow-y-scroll'>
                    <div className='grid grid-cols-1 gap-3'>
                        <div>
                            <label className="block text-left font-medium text-gray-700 mb-1">Assign Date:
                                <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                    <span className=" absolute top-[-2px] left-[3px]">*</span>
                                </span>
                            </label>
                            <div className="grid grid-cols-2 items-center gap-2">
                                <div id="1" onClick={onAssignDate} className={`${formData?.assign_date === "1" ? " bg-blue-950 text-white grayBlurShadow" : "bg-white text-black border border-gray-400"} py-2 px-1 text-center navAnimation rounded-lg cursor-pointer`}>
                                Today
                                </div>
                                <div id="2" onClick={onAssignDate} className={`${formData?.assign_date === "2" ? " bg-blue-950 text-white grayBlurShadow" : "bg-white text-black border border-gray-400"} py-2 px-1 text-center navAnimation rounded-lg cursor-pointer`}>
                                Tomorrow
                                </div>
                            </div>
                            {errors?.assign_date && (<div className=" text-red-700 text-sm font-medium text-left">{errors?.assign_date}</div>)}
                        </div>
                        <Dropdown 
                            id="recruiter_id" 
                            name="recruiter_id"
                            label="Recruiter:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            disabled={disabled}
                            placeholder={`Select`}
                            textColor={disabled && "text-blue-700"}
                            value={formData?.recruiter_id}
                            error={errors?.recruiter_id}
                            options={options}
                            required={true}
                        />     

                    </div>
                </form>
            </div>
        </div>
    );
})

export default RecruiterAssigning;

